<template>
  <!--Update 28/03/2022 09:09:21  D:\www\thaiauto\tainetv2\Book\src\components\taimember\quizEdit.vue-->
  <v-card :loading="loading" class="elevation-0" >   
    <!-- {{itemSelected}}   
    {{pom}} -->
    <v-form
      ref="form"
      v-model="formValid"
      :lazy-validation="lazy"
    >
      <v-container fluid fill-height >
        <v-row no-gutters>

          <v-col cols="12" sm="12" hidden>
            <v-row no-gutters>
              <v-col cols="12" sm="6" class="pr-2">
                <v-text-field counter="20" :dense="text_filled" :filled="text_filled"
                  label="_MemberCode_"
                  v-model="itemSelected.MemberCode"
                  :rules="rules.MemberCode"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>


          
                      <!-- <v-col cols="12" sm="4" class="pr-2">
                        <v-text-field :prefix="currency" ref="Register_capital" counter="100" label="ทุนจดทะเบียน(ล้านบาท)" v-model="initialBalanceFormatted" :rules="rules.Register_capital" :dense="text_filled" :filled="text_filled" />
                      </v-col>
                      <v-col cols="12" sm="4" class="pr-2">
                        <v-text-field :prefix="currency" ref="Paid_capital" counter="100" label="ทุนชำระแล้ว(ล้านบาท)" v-model="initialPaidFormatted" :rules="rules.Paid_capital" :dense="text_filled" :filled="text_filled" />
                      </v-col>
                      <v-col cols="12" sm="6" class="pr-2">
                        <v-text-field ref="agree" counter="100" label="_agree_" v-model="itemSelected.agree" :rules="rules.agree" :dense="text_filled" :filled="text_filled" />
                      </v-col>

                      <v-col v-if="com_memType2" cols="12" sm="12"  class="pr-2">
                        เอกสารประกอบการพิจารณา (แนบพร้อมใบสมัคร) และรับรองสำเนาถูกต้อง โดยผู้มีอำนาจลงนาม (Please upload the following for this application:)
                      </v-col>
                      <v-col v-if="com_memType2" cols="12" sm="6" offset-md="2" class="pr-2">
                        <v-file-input show-size counter multiple label="1. สำเนาหนังสือรับรองการจดทะเบียนกระทรวงพาณิชย์" hint="ขนาดไฟล์ไม่เกิน 2 mb" persistent-hint  />
                        <v-file-input show-size counter multiple label="2. สำเนา ภ.พ. 20 หรือ ภ.พ.01 , 09" hint="ขนาดไฟล์ไม่เกิน 2 mb" persistent-hint  />
                        <v-file-input show-size counter multiple label="3. สำเนาใบอนุญาตประกอบกิจการโรงงาน (ถ้ามี)" hint="ขนาดไฟล์ไม่เกิน 2 mb" persistent-hint  />
                        <v-file-input show-size counter multiple label="4. แผนที่โรงงาน/สำนักงาน" hint="ขนาดไฟล์ไม่เกิน 2 mb" persistent-hint  />
                        <v-file-input show-size counter multiple label="5. Company Profile (ถ้ามี)" hint="ขนาดไฟล์ไม่เกิน 2 mb" persistent-hint  />          
                      </v-col> -->
                      <!-- <v-col v-if="com_memType2" cols="12" sm="6" class="pr-2">
                        <v-file-input show-size counter multiple label="2. สำเนา ภ.พ. 20 หรือ ภ.พ.01 , 09" hint="ขนาดไฟล์ไม่เกิน 2 mb" persistent-hint  />
                      </v-col>
                      <v-col v-if="com_memType2" cols="12" sm="4" class="pr-2">
                        <v-file-input show-size counter multiple label="3. สำเนาใบอนุญาตประกอบกิจการโรงงาน (ถ้ามี)" hint="ขนาดไฟล์ไม่เกิน 2 mb" persistent-hint  />
                      </v-col>
                      <v-col v-if="com_memType2" cols="12" sm="4" class="pr-2">
                        <v-file-input show-size counter multiple label="4. แผนที่โรงงาน/สำนักงาน" hint="ขนาดไฟล์ไม่เกิน 2 mb" persistent-hint  />
                      </v-col>
                      <v-col v-if="com_memType2" cols="12" sm="4" class="pr-2">
                        <v-file-input show-size counter multiple label="5. Company Profile (ถ้ามี)" hint="ขนาดไฟล์ไม่เกิน 2 mb" persistent-hint  />
                      </v-col> -->

                      <!-- term -->
                      <!-- <v-col v-if="com_memType2" cols="12" sm="6" offset-md="2" class="pr-2">
                        <v-file-input show-size counter multiple label="1. สำเนาหนังสือรับรองการจดทะเบียนกระทรวงพาณิชย์" hint="ขนาดไฟล์ไม่เกิน 2 mb" persistent-hint  />
                        <v-file-input show-size counter multiple label="2. สำเนา ภ.พ. 20 หรือ ภ.พ.01 , 09" hint="ขนาดไฟล์ไม่เกิน 2 mb" persistent-hint  />
                        <v-file-input show-size counter multiple label="3. สำเนาใบอนุญาตประกอบกิจการโรงงาน (ถ้ามี)" hint="ขนาดไฟล์ไม่เกิน 2 mb" persistent-hint  />
                        <v-file-input show-size counter multiple label="4. แผนที่โรงงาน/สำนักงาน" hint="ขนาดไฟล์ไม่เกิน 2 mb" persistent-hint  />
                        <v-file-input show-size counter multiple label="5. Company Profile (ถ้ามี)" hint="ขนาดไฟล์ไม่เกิน 2 mb" persistent-hint  />          
                      </v-col>
            -->
            
          <v-col v-if="com_memType2" cols="12" sm="12" offset-md="2" class="pr-2" >

                            <v-layout row wrap text-left>
                              <v-flex xs-12>
                                <div><strong>ไฟล์แนบ: <span style="color: red">กรุณากดปุ่ม Upload เพื่อส่งเอกสาร</span></strong>&nbsp;</div>
                                <dropzonemember
                                  v-if="true" 
                                  @uploadSuccess="test"
                                  dzName="member_Att"
                                  ref="dz"
                                  :appName="'member'"
                                  :nameCode="'*'"
                                  :code="itemSelected.MemberCode"
                                  :list="''"  
                                  :maxSize="2"
                                  :canDelete="true"
                                  :canUpload="true"
                                  :clickable="false"
                                ></dropzonemember>
                                <!-- nameCode=ชื่อไฟล์, appname=ชื่อโฟลเดอร์, code=Subfolder -->
                              </v-flex>
                            </v-layout>
          </v-col>
            <!-- <v-col v-if="com_memType2" cols="12" sm="6" offset-md="2" class="pr-2" style="margin-top: 16px;">

                              <v-layout row wrap text-left>
                                <v-flex xs-12>
                                  <div><strong>ไฟล์แนบ2:</strong>&nbsp;</div>
                                  <dropzonemember
                                    v-if="true"
                                    @uploadSuccess="test"
                                    :code="'tai-0001'"
                                    dzName="member_Att"
                                    ref="dz"
                                    :appName="'member'"
                                    :list="''"
                                    :maxSize="2"
                                    :canDelete="this.$store.state.users.main.Department === 'Information Technology Division'"
                                    :canUpload="this.$store.state.users.main.Department === 'Information Technology Division'"
                                  ></dropzonemember>
                                </v-flex>
                              </v-layout>
            </v-col>    -->
               
          <v-col v-if="com_memType2" cols="12" sm="12" class="pr-2" style="margin-top: 25px;">
            <!-- <v-text-field ref="agree" counter="100" label=" I agree to these" v-model="itemSelected.agree" :rules="rules.agree" :dense="text_filled" :filled="text_filled" /> -->

            <!-- <div class="tacbox"> -->
              <!-- <v-checkbox  ref="agree" label=" I agree to these" v-model="itemSelected.agree" :rules="rules.agree"   /> -->
              <!-- <input id="checkbox" type="checkbox" ref="agree" v-model="itemSelected.agree" :rules="rules.agree" /> 
              <label for="checkbox"> I agree to these <a href="#">Terms and Conditions</a></label> -->
              <!-- start Term -->
                <v-dialog
                  v-model="dialog"
                  width="800px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <!-- <v-btn
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      ข้อตกลงและเงื่อนไข
                    </v-btn> -->
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="text-h5">ข้อตกลงและเงื่อนไขการสมัครสมาชิกสถาบันยานยนต์ออนไลน์</span>
                    </v-card-title>
                    <v-card-text>
                          การสมัครสมาชิกสถาบันยานยนต์ออนไลน์ เป็นแพลตฟอร์มที่ถูกสร้างขึ้น เพื่อใช้เป็นช่องทางในการอำนวยความสะดวกและประชาสัมพันธ์ ข้อมูล ข่าวสารที่น่าสนใจผ่านช่องทางออนไลน์ โดย<b>ผู้สมัครสมาชิกสถาบันยานยนต์ (ผู้สมัครฯ)</b> สามารถขอรับบริการและใช้บริการบนเว็บไซต์เกี่ยวกับการเรียนรู้ผ่านช่องทางดังกล่าวได้<br>
                          การตกลงสมัครสมาชิกสถาบันยานยนต์ออนไลน์ ถือว่าผู้สมัครได้อ่านและทำความเข้าใจข้อตกลงและเงื่อนไขแพลตฟอร์มออนไลน์ (ซึ่งต่อไปจะเรียกว่า “ข้อตกลงและเงื่อนไข”) โดยละเอียดแล้ว และผู้ใช้บริการยอมรับข้อตกลงและเงื่อนไขทุกประการ<br>
                          ทั้งนี้ <b>อุตสาหกรรมพัฒนามูลนิธิ สถาบันยานยนต์ (“สถาบันยานยนต์”)</b> ขอสงวนสิทธิในการปรับเปลี่ยนเงื่อนไขของข้อตกลงและเงื่อนไขฉบับนี้ได้โดยไม่ต้องแจ้งให้ทราบล่วงหน้า โดยผู้สมัครสมาชิกฯ ยอมรับการแจ้งเตือนหรือแจ้งการเปลี่ยนแปลงผ่านอีเมล และผู้ใช้บริการตกลงยอมรับข้อผูกพันใด ๆ ที่เกิดจากการเปลี่ยนแปลงข้อตกลงและเงื่อนไขฉบับนี้หลังจากมีการแจ้งเตือนดังกล่าวเป็นเวลา 24 ชั่วโมง <br>
                          <ol> 
                            <li><b>การดำเนินการเกี่ยวกับข้อมูลส่วนบุคคล</b>
                                    <ol>
                                        <li>“ข้อมูลส่วนบุคคล” หมายความรวมถึง
                                          <ol>
                                                <li>ข้อมูลส่วนตัว ได้แก่ ชื่อ นามสกุล ชื่อธุรกิจ ประเภทธุรกิจ</li>
                                                <li>ข้อมูลการติดต่อ ได้แก่ ที่อยู่ สถานที่ทำงาน หมายเลขโทรศัพท์ อีเมล</li>
                                          </ol>
                                        </li>        
                                        <li>วัตถุประสงค์ของการเก็บรวบรวม ใช้ เปิดเผย ข้อมูลส่วนบุคคล
                                          <ol>
                                                <li>เพื่อเป็นฐานข้อมูลในการวิเคราะห์และจัดทำแผนการการให้บริการ</li>
                                                <li>เพื่อเป็นฐานข้อมูลในการวิจัยหรือจัดทำสถิติ การปรับปรุงคุณภาพของการให้บริการของสถาบันยานยนต์ การโฆษณาและจัดทำข่าวประชาสัมพันธ์</li>
                                                <li>เพื่อเป็นฐานข้อมูลในการติดต่อกลับเพื่อนำเสนอบริการต่าง ๆ ของสถาบันยานยนต์ </li>
                                          </ol>
                                        </li>        
                                      <li>การแบ่งปันข้อมูลให้แก่บุคคลที่สาม</li>
                                              สถาบันยานยนต์ จะเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้บริการแก่บุคคลที่สามใด ๆ ที่จำเป็นต้องใช้ข้อมูลดังกล่าว เพื่อวัตถุประสงค์ตามข้อ 1.2 โดยบุคคลที่สามหมายความรวมถึง ผู้แทนในการให้บริการที่ได้รับมอบหมายในงานบริการนั้น ๆ 
                                        <li>เงื่อนไขอื่น ๆ ที่เกี่ยวข้องกับการประมวลผลข้อมูลส่วนบุคคล
                                          <ol>
                                              <li>สถาบันยานยนต์จะเก็บรวบรวมใช้ และเปิดเผยข้อมูลส่วนบุคคลของสมาชิกฯ เพื่อวัตถุประสงค์ตามข้อ 1.2 เท่านั้น</li>
                                              <li>สถาบันยานยนต์ จะดูแลไม่ให้ผู้ปฏิบัติงานของสถาบันยานยนต์ เปิดเผย แสดง หรือทำให้ปรากฏในลักษณะอื่นใดซึ่งข้อมูลส่วนบุคคลของผู้ใช้บริการต่อบุคคลภายนอก เว้นแต่จะเป็นไปตามเงื่อนไขภายใต้กฎหมายคุ้มครองข้อมูลส่วนบุคคล</li>
                                              <li>สถาบันยานยนต์ กำหนดให้มีมาตรการในการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลอย่างเหมาะสมและสอดคล้องกับการรักษาความลับของข้อมูลส่วนบุคคล</li>
                                              <li>ผู้สมัครสมาชิกฯ สามารถใช้สิทธิในความเป็นส่วนตัวของข้อมูลส่วนบุคคลได้ตามเงื่อนไข  ภายใต้กฎหมายคุ้มครองข้อมูลส่วนบุคคล โดยแจ้งความประสงค์มาที่ สถาบันยานยนต์ (สำนักงานกล้วยน้ำไท) ชั้น 3-4 อาคารสำนักพัฒนาอุตสาหกรรมรายสาขา (สพข.) ซ.ตรีมิตร กล้วยน้ำไท ถ.พระรามที่ 4 แขวงคลองเตย เขตคลองเตย กรุงเทพฯ 10110 หมายเลขโทรศัพท์: 02 712 2414</li>
                                              <li>สถาบันยานยนต์ จะเก็บ ใช้ และเปิดเผยข้อมูลส่วนบุคคลของผู้สมัครสมาชิกฯ ตราบเท่าที่จำเป็น</li>
                                          </ol>
                                        </li>        
                                    </ol>
                            </li>        
                            <li><b>เครื่องหมายการค้า เครื่องหมายบริการ ลิขสิทธิ์ และสิทธิในทรัพย์สินทางปัญญาอื่น ๆ</b></li>
                                    ข้อมูลที่กำหนดหรือแสดงอยู่ใน www.thaiauto.or.th เป็นทรัพย์สินของสถาบันฯ โดยหมายความรวมถึง เครื่องหมายการค้า เครื่องหมายบริการ ชื่อทางการค้า และสัญลักษณ์ทั้งหมดที่อ้างอิงหรือกำหนดอยู่บนเว็บไซต์ โดยไม่จำต้องคำนึงถึงว่าเครื่องหมายการค้า เครื่องหมายบริการ และสัญลักษณ์ดังกล่าว ได้รับการจดทะเบียนแล้วหรือไม่ (ซึ่งรวมเรียกว่า "เครื่องหมายการค้า")<br>
                                    สถาบันยานยนต์ ไม่อนุญาตหรือให้สิทธิในการใช้ข้อมูลและเครื่องหมายการค้าใด ๆ ที่กล่าวข้างต้น รวมถึงไม่อนุญาตให้กระทำการใด ๆ อันเป็นการเปลี่ยนแปลง แก้ไข ทำใหม่ ทำซ้ำ ดาวน์โหลด์ ส่งผ่าน (ไม่ว่าในรูปแบบ ใด ๆ หรือโดยวิธีการใด ๆ) หรือใช้ในลักษณะใด ๆ ก็ตามเพื่อวัตถุประสงค์ในทางการค้า เว้นแต่จะได้รับความยินยอมเป็นลายลักษณ์อักษรล่วงหน้าจากสถาบันยานยนต์ก่อน<br>
                            
                            <li><b>การบอกเลิกข้อตกลงและเงื่อนไข ข้อจำกัดในการเข้าสู่ข้อมูล และข้อห้ามการใช้งาน</b>
                                ในกรณีที่สถาบันยานยนต์ เห็นว่าข้อใดข้อหนึ่งดังต่อไปนี้เกิดขึ้นหรืออาจจะเกิดขึ้นกับผู้สมัครสมาชิกฯ สถาบันฯ สามารถใช้ดุลพินิจแต่เพียงผู้เดียวในการบอกเลิกข้อตกลงและเงื่อนไขนี้ หรือการยกเลิกการให้เข้าสู่ข้อมูลไม่ว่าบางส่วนหรือทั้งหมดของ สถาบันยานยนต์ รวมทั้งบริการที่เกี่ยวข้องในส่วนใด ๆ ของสถาบันฯ โดยไม่จำเป็น ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า โดยสถาบันฯ ไม่มีหน้าที่รับผิดชอบต่อความเสียหายที่เกิดขึ้นแก่ผู้ใช้บริการจากการบอกเลิกข้อตกลงและเงื่อนไขดังกล่าว
                                    <ol>
                                      <li>ในกรณีที่ผู้สมัครสมาชิกสถาบันยานยนต์ สำหรับวัตถุประสงค์ที่ไม่ชอบด้วยกฎหมาย</li>
                                      <li>ในกรณีที่สถาบันยานยนต์เชื่อว่ามีการขาดความน่าเชื่อถือของผู้ใช้บริการ</li>
                                      <li>ในกรณีที่ผู้สมัครสมาชิกฯ ไม่สามารถติดต่อในช่องทางที่ให้ไว้ได้ในระยะเวลา 1 ปี ตามเงื่อนไขที่สถาบันยานยนต์ กำหนด</li>
                                      <li>ในกรณีที่ผู้ใช้บริการได้ดำเนินการที่สถาบันยานยนต์ เห็นว่าไม่เหมาะสม</li>
                                    </ol>
                            </li>    
                                
                            <li><b>ข้อจำกัดความรับผิด</b>
                                    <ol>
                                      <li>เมื่อผู้สมัครสมาชิกฯ ได้ลงทะเบียนสมัครสมาชิก แล้ว สถาบันยานยนต์ จะทำการเก็บรักษาข้อมูลสำหรับการเข้าใช้งานไว้โดยไม่เปิดเผยต่อผู้อื่นหรือเปิดเผยต่อสาธารณะ หากข้อมูลดังกล่าวถูกเปิดเผยจากการกระทำของผู้ใช้บริการไม่ว่าโดยทางตรงหรือทางอ้อม สถาบันยานยนต์ จะไม่รับผิดชอบต่อการกระทำนั้น ๆ</li>
                                      <li>สมาชิกฯ ต้องไม่กระทำการใด ๆ อันเป็นเหตุให้เกิดความเสียหายต่อบุคคลภายนอก หรือไม่กระทำการใดๆ อันเป็นความผิดต่อพระราชบัญญัติว่าด้วยการกระทำความผิดเกี่ยวกับคอมพิวเตอร์ พ.ศ. 2560 หรือกฎหมายอื่นใด หากสถาบันยานยนต์ ตรวจพบว่ามีการกระทำหรืองดเว้นการกระทำใดดังกล่าวข้างต้น สถาบันยานยนต์ สามารถยกเลิกการให้บริการ และ/หรือ ระงับบัญชีผู้ใช้งานได้ และหากการกระทำดังกล่าวข้างต้นก่อให้เกิดความเสียหายต่อ สถาบันยานยนต์ ผู้ใช้บริการจะต้องรับผิดชอบในความเสียหายต่อสถาบันยานยนต์ ตามมูลค่าความเสียหายที่เกิดขึ้นจริง</li>
                                      <li>สถาบันยานยนต์ ไม่ได้ให้คำรับรองหรือรับประกันโดยชัดแจ้งหรือโดยปริยายแต่อย่างใด เกี่ยวกับความเหมาะสม ความน่าเชื่อถือ ความมีอยู่และใช้งานได้ทันกาล ทันเวลา การไม่มีไวรัสหรือสิ่งอื่นใดที่เป็นอันตราย รวมทั้งความถูกต้องของข้อมูล ซอฟท์แวร์ สินค้าและรูปแบบแผนผังใด ๆ ที่เกี่ยวข้องที่ปรากฏอยู่บน สถาบันยานยนต์ ทั้งนี้ ไม่ว่าจะเพื่อวัตถุประสงค์ใด ๆ ก็ตาม
                                      สถาบันยานยนต์ ไม่มีความรับผิดและจะไม่รับผิดสำหรับความสูญเสียหรือความเสียหายใด ๆ ที่เกิดขึ้นไม่ว่าจะโดยตรงหรือโดยอ้อม (รวมทั้งความสูญเสียหรือความเสียหายกรณีพิเศษ) จากการใช้ สถาบันยานยนต์ โดยผู้สมัครสมาชิก</li>
                                    </ol>
                            </li>    
                            <li><b>การรักษาข้อมูลความลับ</b></li>
                            สถาบันยานยนต์ ตกลงที่จะดูแลรักษาข้อมูลความลับของสมาชิกฯ เพื่อให้เป็นความลับ โดยจะไม่เปิดเผยข้อมูลของผู้ให้บริการให้บุคคลใดทราบ เว้นแต่จะได้รับความยินยอมเป็นลายลักษณ์อักษรจากสมาชิกฯ และ/หรือ เป็นการขอข้อมูลตามที่กฎหมายกำหนด
                            
                            <li><b>ช่องทางการติดต่อ</b></li>
                            สถาบันยานยนต์ (สำนักงานกล้วยน้ำไท) ชั้น 3-4 อาคารสำนักพัฒนาอุตสาหกรรมรายสาขา (สพข.) ซ.ตรีมิตร กล้วยน้ำไท ถ.พระรามที่ 4 แขวงคลองเตย เขตคลองเตย กรุงเทพฯ 10110<br>
                            หมายเลขโทรศัพท์ : 02 712 2414<br>
                            Website: <a href="www.thaiauto.or.th">www.thaiauto.or.th</a><br>
                            
                            <li><b>กฎหมายที่ใช้บังคับ</b></li>
                            การตีความและการบังคับตามข้อตกลงและเงื่อนไขฉบับนี้ให้เป็นไปตามกฎหมายไทย
                          </ol>

                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="green darken-1"
                        text
                        @click="dialog = false"
                      >
                        <!-- Disagree -->
                      </v-btn>
                      <v-btn
                        color="green darken-1"
                        text
                        @click="dialog = false"
                      >
                        Close<!-- Agree -->
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

              <!-- End Term -->
            <!-- </div>  -->
            
          </v-col>

        </v-row>    

      </v-container>

    </v-form>
  </v-card>  
  
</template>

<script>
import itemService from '@/store/api/services/taimemberService'
import dropzonemember from '@/components/dropzonemember'
// import dropzonemember from '@/components/dropzonememberV2'
// import dropzonemember from '@/components/dropzoneCompV2'
export default {
  name: 'quizEdit',
  components: {
    dropzonemember
    // VueSignaturePad,
    // Itisopdf
  },
   props: {
    dialogClose: {
      type: Boolean
    },
    itemSelected: {
      type: Object,
      default: function() {
        return {Register_capital:0, Paid_capital:0}        
      }      
    },
    action: {
      type: String,
      default: function() {
        return 'add'
      }
    },
    pom: {
      type: String,
      default: function() {
        return 'add'
      }
    },
  },
  
  data() {
    return {
      // Start upload file
      pathStatic: process.env.VUE_APP_STATIC,
      pathSignature: 'fileUpload/memberfiles/', 
      errorMessages: [],
      // End upload
      currency: "฿",
      initialBalance: null,     
      initialPaid: null,
     
      pomtest:{pp:null},

      dialog: false,
      panel: [0],
      disabled: false,
      readonly: false,
      Business_Title: ['ผู้ประกอบรถยนต์', 'ผู้ผลิตชิ้นส่วนรถยนต์', 'ผู้ผลิตชิ้นส่วนอะไหล่ทดแทน(REM)', 'ผู้ประกอบรถจักรยานยนต์', 'ผู้ผลิตชิ้นส่วนรถจักรยานยนต์'],
      Tier_Title: ['1st Tier', '2nd Tier', '3rd Tier'],
      Related_industry: ['เหล็ก', 'พลาสติก', 'ยาง', 'อิเล็กทรอนิกส์', 'แก้วและกระจก', 'ผ้าและเครื่องหนัง', 'เครื่องจักรกล เครื่องมือ', 'แม่พิมพ์', 'อุปกรณ์จับยึดชิ้นงาน', 'อื่นๆ'],
      Process: ['Casting', 'Forging', 'Plastic Parts', 'Rubber Parts', 'Machining', 'Heat Treatment', 'Surface Treatment', 'Spraying-Painting', 'Welding', 'Trim', 'อื่นๆ'],
      Product_type: ['Accessories', 'Engine', 'Suspension& Brake', 'Body', 'Exterior', 'Electronic', 'Interior', 'Drive, Transmission&Steering','EV', 'Battery', 'Software', 'อื่นๆ'],
      Quality_system: ['ISO/TS16949', 'ISO/TS17025', 'ISO9001', 'ISO14001', 'OHSAS 18001 (TIS 18001)', 'อื่นๆ'],
      Tai_activity: ['การทดสอบผลิตภัณฑ์', 'การพัฒนาผลิตภัณฑ์', 'การพัฒนาบุคลากร', 'การพัฒนากระบวนการผลิต', 'เพื่อเพิ่มผลิตภาพ', 'ข้อมูลด้านวิเคราะห์ธุรกิจ ที่เกี่ยวข้องกับอุตสาหกรรมยานยนต์และชิ้นส่วนยานยนต์', 'อื่นๆ'],
      pathStatic: process.env.VUE_APP_STATIC,
      errorMessages: [],
      lazy: false,
      debug: false,
      formValid: true,
      loading: true,
      text_filled: true,
      oldItem: {},
      agree: false,
      rules: {
        MemberCode: [],
        TradeCode: [],
        Id: [],
        Share_thai: [val => ((val >= 0 && val <= 100) ) || 'Number has to be between 0 and 100'],
        Share_foreign: [val => ((val >= 0 && val <= 100) ) || 'Number has to be between 0 and 100'],
        Nationshare: [],
        Original_com: [],
        Business_Title: [],
        Tier_Title: [],
        Related_industry: [],
        Related_other: [],
        Process: [],
        Process_other: [],
        Product_type: [],
        Product_type_other: [],
        Quality_system: [],
        Quality_system_other: [],
        Main_product1: [],
        item1: [],
        Main_product2: [],
        item2: [],
        Main_product3: [],
        item3: [],
        Domestic: [],
        Export: [],
        Export_country: [],
        Main_domestic: [],
        Main_foreign: [],
        Staff: [],
        Register_capital: [],
        Paid_capital: [],
        Tai_activity: [],
        Tai_activity_other: [],
        agree: [val => (!!val) || 'This field is required'],

            // val => (!!val) || 'This field is required',
            // val => (!!val.toString()) || 'ห้ามเป็นค่าว่าง',
            // val => (val && val.length >= 3) || 'ต้องมีอย่างน้อย 3 ตัวอักษร',
            // val => (((val.length || 0) <= 500) ) || 'ต้องไม่เกิน 500 ตัวอักษร',
            // val => (!val.trim() || !isNaN((val)) ) || 'ต้องเป็นตัวเลข',
            // val => (Number.isInteger(parseFloat(val) ) ) || 'ต้องเป็นจำนวนเต็ม',
            // val => ((val >= 0 && val <= 999) ) || 'Number has to be between 0 and 999',

            // val => { // email check
            //   const patternEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            //   return patternEmail.test(val) || 'Invalid e-mail.'
            // },
      },
      //data()
    }
  },
  watch: {
    itemSelected: function(value, oldValue) {
      this.$nextTick(() => {
        console.log(value)
        if (value.MemberCode !== oldValue.MemberCode){
          console.log('change Key')
          this.initLoad()
        }
      })
    },
    formValid: function(value) {
      this.$emit('valid', value)
    },
    //watch()
  },
 computed: {
    initialPaidFormatted: {
      get: function () {
        if(this.itemSelected.Paid_capital){
          return this.formatAsCurrency(this.itemSelected.Paid_capital, 0);
        }else{
          return this.formatAsCurrency(0, 0);
        }
      },
      
      set: function (newValue) {
        this.itemSelected.Paid_capital = Number(newValue.replace(/[^0-9\.]/g, ""));
      },
    },
    initialBalanceFormatted: {
      get: function () {
        if(this.itemSelected.Register_capital){
          return this.formatAsCurrency(this.itemSelected.Register_capital, 0);
        }else{
          return this.formatAsCurrency(0, 0);
        }
        
      },
      
      set: function (newValue) {
        this.itemSelected.Register_capital = Number(newValue.replace(/[^0-9\.]/g, ""));
      },
      
    },
    com_memType1(){
      return this.itemSelected.Member_Type !=='นิติบุคคล/Juristic Persons'
    },
    com_memType2(){
      return this.itemSelected.Member_Type !=='บุคคลธรรมดา/Person'
    }
    
  //computed()
  },
  mounted: function() {
    this.initLoad()
    //mounted()
  },
  methods: {
    checkPermission(permissionArray) {
      return this.$store.getters.checkPermission(permissionArray)
    },
    errorHandel(res) {
      if (res.status === 401) {
        this.redirect = '/signin'
        this.$router.push(this.redirect)
      }
    },
    initLoad() {
      this.loading = true 
      this.oldItem = Object.assign({}, this.itemSelected)
      this.$refs.form.resetValidation()
      if (this.action === 'add' || this.action === '') {
        console.log('init field for add action', this.itemSelected)
        // this.$refs.{{input-Date}}.setToday()
      }
      console.log('init', this.itemSelected)
      this.loading = false
    },
    itemCancel() {
      this.itemSelected = Object.assign({}, this.oldItem)
    },
    async Save() {
      this.loading = true
      console.log('quizEdit Save 1')
      if (this.itemSelected.ModifyCode) {
        if (this.itemSelected.ModifyCode.substr(0, 4) !== this.$store.state.users.main.empCode) {
          this.itemSelected.ModifyCode = this.$store.state.users.main.empCode + ',' + this.itemSelected.ModifyCode
          this.itemSelected.ModifyCode = this.itemSelected.ModifyCode.substr(0, 25)
        }
      } else {
        this.itemSelected.ModifyCode = this.$store.state.users.main.empCode
      }
      var modifyDate = new Date().toISOString().slice(0, 19)
      this.itemSelected.ModifyDate = modifyDate
      if (this.action !== 'add') {
        // Update Event
        console.log('quizEdit Save Update')
        let response = await itemService.quizUpdate(this.itemSelected)
        console.log('quizEdit Save Update then')
        if (response.data.error === '') {
          console.log('quizEdit Save Update then OK')
          this.itemSelected = response.data.data[0]
          let itemSelected_update = response.data.data[0] // this.itemSelected
          this.$emit('update', itemSelected_update)
          this.loading = false
          return true
        } else {
          console.log('quizEdit Save Update then error')
          alert('!!เกิดข้อผิดพลาด\n' + response.data.error)
          this.loading = false            
          return false
        }
      } else {
        // Insert Event
        console.log('quizEdit Save Insert')
        let response = await itemService.quizInsert(this.itemSelected)
        console.log('quizEdit Save Insert then ')
        if (response.data.error === '') {
          console.log('quizEdit Save Insert then OK')
          // this.itemSelected = response.data.data[0]
          let itemSelected = response.data.data[0] // this.itemSelected
          this.$emit('update', itemSelected)
          this.loading = false
          return true
        } else {
          console.log('quizEdit Save Insert then Error')
          alert('!!เกิดข้อผิดพลาด\n' + response.data.error)
          this.loading = false
          return false
        }
      }
    },
    formatAsCurrency(value, dec) {
      dec = dec || 0;
      if (value === null) {
        return 0;
      }
      return "" + value.toFixed(dec).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    },    
    signLoad() {
        if (this.$route.params.ReqCode) {
          if (this.$refs.signaturePad) {
            this.$refs.signaturePad.clearSignature()
            // this.$refs.signaturePad.fromDataURL(process.env.VUE_APP_API_PATH + 'fileUpload/itisofiless/' + this.itReq.ReqCode.replace('/', '-') + '_sign00.png')
            this.$refs.signaturePad.fromDataURL(process.env.VUE_APP_API_PATH + 'fileUpload/memberfiles/' + this.itReq.ReqCode.replace('/', '-') + '_sign00.png')
          }
          // this.$refs.signaturePad.images = [{src: process.env.VUE_APP_API_PATH + this.pathSignature + this.$route.params.ReqCode.replace('/', '-') + '_sign01.png'}]
          // this.$refs.signaturePad01.mergeImageAndSignature(this.$refs.signaturePad.getPropImagesAndCacheImages())
          // this.$refs.signaturePad01.signatureData = this.$refs.signaturePad.signatureData
          // console.log('this.$refs.signaturePad.signatureData', this.$refs.signaturePad.signatureData)
          // console.log('this.$refs.signaturePad01.signatureData', this.$refs.signaturePad01.signatureData)
          // console.log('itReq.signReq', this.itReq.signReq)
        }
    },
    ssload() {
        var Canvas2 = document.getElementById('canvasDiv')
        var Context2 = Canvas2.getContext('2d')
        var image = new Image()
        image.src = this.signImage01
        Canvas2.width = image.width
        Canvas2.height = image.height
        // console.log('image.src', image.src)
        Context2.drawImage(image, 0, 0)
        // console.log('canvas.dataURL', Canvas2.toDataURL('image/png'))
    },
    imageReceived() {
        let canvas = document.createElement('canvas')
        let context = canvas.getContext('2d')

        canvas.width = this.downloadedImg.width
        canvas.height = this.downloadedImg.height
        context.drawImage(this.downloadedImg, 0, 0)

        try {
          localStorage.setItem('saved-image-sign01', '')
          localStorage.setItem('saved-image-sign01', canvas.toDataURL('image/png'))
          this.$refs.signaturePad.fromDataURL(canvas.toDataURL('image/png'))
        } catch (err) {
          console.log('Error: ' + err)
        }
    },
    imageReceived02() {
        let canvas = document.createElement('canvas')
        let context = canvas.getContext('2d')

        canvas.width = this.downloadedImg02.width
        canvas.height = this.downloadedImg02.height
        context.drawImage(this.downloadedImg02, 0, 0)

        try {
          localStorage.setItem('saved-image-sign02', '')
          localStorage.setItem('saved-image-sign02', canvas.toDataURL('image/png'))
          this.$refs.signaturePad02.fromDataURL(canvas.toDataURL('image/png'))
        } catch (err) {
          console.log('Error: ' + err)
        }
    },
    imageReceived03() {
        let canvas = document.createElement('canvas')
        let context = canvas.getContext('2d')

        canvas.width = this.downloadedImg03.width
        canvas.height = this.downloadedImg03.height
        context.drawImage(this.downloadedImg03, 0, 0)

        try {
          localStorage.setItem('saved-image-sign03', canvas.toDataURL('image/png'))
          this.$refs.signaturePad03.fromDataURL(canvas.toDataURL('image/png'))
        } catch (err) {
          console.log('Error: ' + err)
        }
    },
    startDownloadSing01() {
        // this.$nextTick(() => {
        // console.log('this.itReq.sign01', this.itReq.sign01)
        // if (this.itReq.sign01) {
        localStorage.setItem('saved-image-sign01', '')
        // console.log('startdownlosd 01', this.signImage01)
        this.downloadedImg = new Image()
        this.downloadedImg.crossOrigin = 'Anonymous'
        this.downloadedImg.addEventListener('load', this.imageReceived, false)
        this.downloadedImg.src = this.signImage01
        // }
        // })
    },
    startDownloadSing02() {
        // console.log('startdownlosd 02', this.signImage02)
        localStorage.setItem('saved-image-sign02', '')
        this.downloadedImg02 = new Image()
        this.downloadedImg02.crossOrigin = 'Anonymous'
        this.downloadedImg02.addEventListener('load', this.imageReceived02, false)
        this.downloadedImg02.src = this.signImage02
    },
    startDownloadSing03() {
        // console.log('startdownlosd 03', this.signImage03)
        localStorage.setItem('saved-image-sign03', '')
        this.downloadedImg03 = new Image()
        this.downloadedImg03.crossOrigin = 'Anonymous'
        this.downloadedImg03.addEventListener('load', this.imageReceived03, false)
        this.downloadedImg03.src = this.signImage03
    }, 
      // signLoad() {
      //   if (this.$route.params.ReqCode) {
      //     if (this.$refs.signaturePad) {
      //       this.$refs.signaturePad.clearSignature()
      //       // this.$refs.signaturePad.fromDataURL(process.env.VUE_APP_API_PATH + 'fileUpload/itisofiless/' + this.$route.params.ReqCode.replace('/', '-') + '_sign00.png')
      //       this.$refs.signaturePad.fromDataURL(process.env.VUE_APP_API_PATH + 'fileUpload/itisofiless/' + this.TradeCode.replace('/', '-') + '_sign00.png')
      //     }
      //     // this.$refs.signaturePad.images = [{src: process.env.VUE_APP_API_PATH + this.pathSignature + this.$route.params.ReqCode.replace('/', '-') + '_sign01.png'}]
      //     // this.$refs.signaturePad01.mergeImageAndSignature(this.$refs.signaturePad.getPropImagesAndCacheImages())
      //     // this.$refs.signaturePad01.signatureData = this.$refs.signaturePad.signatureData
      //     // console.log('this.$refs.signaturePad.signatureData', this.$refs.signaturePad.signatureData)
      //     // console.log('this.$refs.signaturePad01.signatureData', this.$refs.signaturePad01.signatureData)
      //     // console.log('itReq.signReq', this.itReq.signReq)
      //   }
      // },

    // current date
     currentDateTime() {
      const current = new Date();
      const date = current.getFullYear()+'-'+(current.getMonth()+1)+'-'+current.getDate();
      const time = current.getHours() + ":" + current.getMinutes() + ":" + current.getSeconds();
      const dateTime = date +' '+ time;

      return dateTime;
    }
    

    //methods()
  }
}
// term

//test



</script>
<style>
.small-radio i {
  font-size: 15px;
}
.small-radio label {
  font-size: 14px;
  padding-left: 0px;
  margin-left: -4px;
}
.small-radio .v-radio {
  padding: 0px;
}
.small-radio [class*="__ripple"] {
  left: -9;
}
/* term */
.tacbox {
  display:block;
  padding: 1em;
  margin: 2em;
  border: 3px solid #ddd;
  background-color: #eee;
  max-width: 800px;
}

input {
  height: 2em;
  width: 2em;
  vertical-align: middle;
}
ol { counter-reset: item }
li{ display: block }
li:before { content: counters(item, ".") " "; counter-increment: item }
</style>
